import React from 'react';
import MonitorInventarioCV from './controladorVista/monitorInventarioCV';

const MonitorInventario: React.FunctionComponent = () => <MonitorInventarioCV />;

export default MonitorInventario;
